import React from 'react';

import { Modal, H4 } from '@bigcommerce/big-design';

const UnsavedChangesDialog = ({ setDisplayUnsavedDialog, savePick, closePick }) => {
  const close = () => {
    setDisplayUnsavedDialog(false);
    closePick();
  }

  const saveAndClose = () => {
    savePick();
    setDisplayUnsavedDialog(false);
    closePick();
  }

  const hide = () => {
    setDisplayUnsavedDialog(false);
  }

  return(
    <div className="main-overlay main-overlay__info">
      <Modal
        actions={[
          { 
            text: 'Close without saving', 
            onClick: () => close()
          },
          {
            text: 'Save before closing',
            onClick: () => saveAndClose()
          }
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        backdrop={false}
        isOpen={true}
        onClose={() => hide()}
        variant="dialog"
      >
        <br/>
        <H4>Unsaved Changes</H4>
        <div>
          <span className="left-15">Order pick has unsaved changes. Save before closing?</span>
        </div>
      </Modal>
    </div>
  )
}

export default UnsavedChangesDialog;